module.exports = __webpack_public_path__ + "img/20210111_150938.37a89853.jpg";